import { render, staticRenderFns } from "./vat.vue?vue&type=template&id=541d09bc"
import script from "./vat.vue?vue&type=script&lang=js"
export * from "./vat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports